import { useState, useEffect } from 'react';
import axios from 'axios';
import { Zap, Loader2, CheckCircle2 } from 'lucide-react';
import { API } from '../../lib/constants';

export const AutoProcessBadge = ({ onCompleted }) => {
  const [status, setStatus] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let wasBusy = false;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/admin/auto-process`);
        setStatus(data);
        const busy = !!data.scheduled_for || data.processing;
        if (wasBusy && !busy) onCompleted?.();
        wasBusy = busy;
      } catch {}
    };
    poll();
    const id = setInterval(poll, 4000);
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => { clearInterval(id); clearInterval(t); };
  }, [onCompleted]);

  if (!status) return null;

  const secs = status.scheduled_for ? Math.max(0, Math.round((new Date(status.scheduled_for) - Date.now()) / 1000)) : null;

  if (status.processing) {
    return <span className="badge-cyan" data-testid="auto-process-badge"><Loader2 className="w-3 h-3 animate-spin" /> Matching faces now…</span>;
  }
  if (secs !== null) {
    return <span className="badge-lime" data-testid="auto-process-badge"><Zap className="w-3 h-3" /> Auto-matching in {secs}s</span>;
  }
  return (
    <span className="badge-muted" data-testid="auto-process-badge" title={status.last_processed_at || ''}>
      <CheckCircle2 className="w-3 h-3" /> Auto-match on · {status.last_processed_at ? `last run ${new Date(status.last_processed_at).toLocaleTimeString()}` : 'runs 60s after uploads'}
    </span>
  );
};
